import { NavbarGroup, NavbarHeader, NavbarItem } from '@safarilaw-webapp/shared/app-bootstrap/data-access';

export const environmentImports: NavbarItem[] | NavbarGroup[] | NavbarHeader[] = [];
